import { createAsyncThunk } from "@reduxjs/toolkit";
import * as ProjectServiceApi from "apis/ProjectServiceApi";
import { ProjectData } from "types";

export const createProjectThunk = createAsyncThunk(
    "projects/projectForm/createProject",
    async (projectData: ProjectData, { rejectWithValue }) => {
      try {
        const response = await ProjectServiceApi.createProject(projectData);
        return response;
      } catch (error: any) {
        return rejectWithValue(error.message || "Error creating project");
      }
    }
  );